<template>
  <div class="col-md-11 d-flex flex-column align-items-center router-view-background">
    <div class="col-md-12">
      <div class="form-panel">
        <p class="form-panel__title"><i class="mdi mdi-flask-outline"></i>Análise do serviço</p>
        <v-autocomplete
          class="form-panel__field form-panel__field--wide"
          outlined
          dense
          label="Código do Serviço"
          :items="computedServices"
          item-text="title"
          item-value="id"
          return-object
          v-model="service"
          :disabled="canChangeService"
          :key="serviceSelectKey"
        ></v-autocomplete>

        <template v-if="service">
          <v-autocomplete
            class="form-panel__field"
            outlined
            dense
            label="Laboratório"
            :items="labs"
            item-text="name"
            item-value="id"
            v-model="service.labor_id"
          ></v-autocomplete>

          <div class="form-panel__field">
            <date-picker 
              label="Data da análise"
              dense
              :binding.sync="service.date_analysis"
              :readOnly="false"
            />
          </div>

          <div class="form-panel__toggles">
            <v-switch
              inset
              hide-details
              label="Amostras Vencidas"
              color="var(--green)"
              v-model="service.analysis_outdate"
            ></v-switch>
          </div>
        </template>

        <v-select
          class="form-panel__field"
          label="Integrações"
          :items="[{name: 'Parleite', id: 'parleite'}]"
          outlined
          dense
          hide-details
          item-text="name"
          item-value="id"
          v-model="integrations"
        ></v-select>

        <div class="form-panel__actions">
          <v-btn
            v-if="integrations"
            class="sync-sample"
            @click="getLabSync"
          >
            <i class="mdi mdi-sync pr-1"></i>
            Consultar Análises
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="this.allAnimals.length > 0" class="col-md-12 py-0 d-flex align-items-center justify-content-between table-header-control">
      <span>
        <strong style="color:var(--green)">{{in_page > total_items ? total_items : in_page}}</strong>
        /
        <strong style="color:var(--green)">{{total_items}}</strong> 
        Registros
      </span>
      <div class="d-flex align-items-center table-header-control-paginator">
        <p class="m-0">Exibindo resultados : </p>
        <v-select
          outlined
          dense
          hide-details
          :items="valuesForAmount"
          item-text="title"
          item-value="value"
          :value="valuePerPage"
          @change="$_setAmount"
          class="ml-2"
          style="max-width:100px"
        ></v-select>
      </div>
    </div>
    <div class="col-md-12">
      <the-table 
        :dataItems="computedAnimals"
        :headers="headersForTable"
        :key="tableKey"
      >
        <template v-slot:animal="{item}">
          <div class="d-flex flex-column text-center">
            <span>{{item.animal.name}}</span>
            <div v-if="item.error" class="text-center">
              <i style="color:red" class="mdi mdi-alert"></i>
              <p style="color:red">{{item.error}}</p>
            </div>
        </div>
        </template>
        <template v-slot:fat="{item}">
          <v-text-field
            :key="keysUpdate.inputFatKey"
            ref="fat"
            outlined
            v-model="item.fat"
            :disabled="item.control_next"
            :error-messages="item.fat_errors.value"
            v-tooltip.top="{content:item.fat_errors.tooltip}"
            style="max-height:50px; margin:10px"
            @change="fat_check(item)"
            @input="checkStringLength(item,'fat')"
          ></v-text-field>
        </template>
        <template v-slot:protein="{item}">
          <v-text-field
            :key="keysUpdate.inputProteinKey"
            outlined
            v-model="item.protein"
            :disabled="item.control_next"
            :error-messages="item.protein_errors.value"
            v-tooltip.top="{content:item.protein_errors.tooltip}"
            style="max-height:50px; margin:10px"
            @change="protein_check(item)"
            @input="checkStringLength(item,'protein')"
          ></v-text-field>
        </template>
        <template v-slot:lactose="{item}">
          <v-text-field
            :key="keysUpdate.inputLactoseKey"
            outlined
            v-model="item.lactose"
            :disabled="item.control_next"
            :error-messages="item.lactose_errors.value"
            v-tooltip.top="{content:item.lactose_errors.tooltip}"
            style="max-height:50px; margin:10px"
            @change="lactose_check(item)"
            @input="checkStringLength(item,'lactose')"
          ></v-text-field>
        </template>
        <template v-slot:urea="{item}">
          <v-text-field
            :key="keysUpdate.inputUreaKey"
            outlined
            v-model="item.urea"
            :disabled="item.control_next"
            :error-messages="item.urea_errors.value"
            v-tooltip.top="{content:item.urea_errors.tooltip}"
            style="max-height:50px; margin:10px"
            @change="urea_check(item)"
            @input="checkStringLength(item,'urea')"
          ></v-text-field>
        </template>
        <template v-slot:ccs="{item}">
          <v-text-field
            :key="keysUpdate.inputCssKey"
            outlined
            v-model="item.ccs"
            :disabled="item.control_next"
            :error-messages="item.ccs_errors.value"
            v-tooltip.top="{content:item.ccs_errors.tooltip}"
            style="max-height:50px; margin:10px"
            @change="ccs_check(item)"
            @input="checkStringLength(item,'ccs')"
          ></v-text-field>
        </template>
        <template v-slot:solids="{item}">
          <v-text-field
            :key="keysUpdate.inputSolidsKey"
            outlined
            v-model="item.solids"
            :disabled="item.control_next"
            :error-messages="item.solids_errors.value"
            v-tooltip.top="{content:item.solids_errors.tooltip}"
            style="max-height:50px; margin:10px"
            @change="solids_check(item)"
          ></v-text-field>
        </template>
        <template v-slot:pi="{item}">
          <v-switch
            inset
            class="mt-5"
            color="var(--green)"
            v-model="item.control_next"
            @change="tableKey = tableKey + 1"
            style="width:40px;margin:0 10px"
          ></v-switch>
        </template>
        <template v-slot:classified_comment="{item}">
          <v-text-field
            outlined
            v-model="item.classified_comment"
            style="max-height:50px; margin:10px"
          ></v-text-field>
        </template>
        <template v-slot:actions="{item}">
          <v-btn 
            class="success mr-2"
            @click="saveSingleMilkControl(item)"
          >
            <i class="mdi mdi-check"></i>
          </v-btn>

          <v-btn 
            class="error"
            @click="
              showConfirmationRemoveAnalysis = true,
              analysisToDelete = item
            "
          >
            <i class="mdi mdi-delete"></i>
          </v-btn>
        </template>
      </the-table>
    </div>
    <div class="d-flex justify-content-end mt-10 w-100">
      <v-pagination
        v-model="page"
        :length="total_pages"
        :total-visible="8"
        color="var(--jersey-yellow)"
      ></v-pagination>
    </div>
    <div class="mt-10 w-100">
      <the-actions
        color="#4caf50"
        sub-color="#ffffff"
        action-text="Salvar Análise"
        path-back="Milk-analysis-list"
        @save="saveAnalysis"
        :show-save="true"
      ></the-actions>
    </div>

    <modal-remove-milk-analysis 
      :active="showConfirmationRemoveAnalysis"
      @close="showConfirmationRemoveAnalysis = false"
      @save="removeSingleMilkControl"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DatePicker from "@/components/layout/DatePicker";
import TheTable from "@/components/layout/TheTable";
import TheActions from "@/components/layout/TheActions";
import helpers from "@/mixins/helpers.js";
import ModalRemoveMilkAnalysis from "./ModalRemoveMilkAnalysis";
export default {
  name:"FormMilkControl",
  components:{
    TheTable,
    TheActions,
    DatePicker,
    ModalRemoveMilkAnalysis
  },
  mixins:[helpers],
  data() {
    return {
      integrations:null,
      service:null,
      canChangeService:false,
      serviceSelectKey:0,
      showConfirmationRemoveAnalysis:false,
      analysisToDelete:{},
      headersForTable:[
        {text:"Animal", value:"animal", has_slot:true},
        {text:"Registro", value:"register"},
        {text:"Bottom", value:"code"},
        {text:"Data da Coleta", value:"date_classified"},
        {text:"Gord", value:"fat", has_slot:true},
        {text:"Prot", value:"protein", has_slot:true},
        {text:"Lact", value:"lactose", has_slot:true},
        {text:"Ureia", value:"urea", has_slot:true},
        {text:"ccs", value:"ccs", has_slot:true},
        {text:"Sólidos Totais", value:"solids", has_slot:true},
        {text:"PI", value:"pi", has_slot:true},
        {text:"Observação", value:"classified_comment", has_slot:true},
        {text:"", value:"actions", has_slot:true},
      ],
      valuesForAmount:[
        {title:"10", value:10},
        {title:"25", value:25},
        {title:"50", value:50},
        {title:"100", value:100},
      ],
      valuePerPage:50,
      allAnimals:[],
      originalLabValues:{},
      tableKey:0,
      keysUpdate: {
        inputFatKey:0,
        inputProteinKey:0,
        inputLactoseKey:0,
        inputCssKey:0,
        inputSolidsKey:0
      }
    }
  },
  computed: {
    ...mapState("service", ["service_single", "services", "labs"]),
    computedServices() {
      return this.services.map(service => ({...service, title:service.code + " - " + service.status}))
    },
    checkIfCanSave() {
      const list = JSON.parse(localStorage.getItem("form-milk-analysis"));
      const invalid = list.filter(animal => !animal.lactation.length && animal.first_weight > 0 || 
        !animal.lactation.length && animal.second_weight > 0 ||
        !animal.lactation.length && animal.third_weight > 0);
      if(invalid.length) {
        return false;
      } else {
        return true;
      }
    },
    computedAnimals() {
      return this.allAnimals.filter(animal => animal.has_analysis === true);
    }
  },
  methods: {
    ...mapActions("service", [
      "actionGetSingleService", 
      "actionGetServices", 
      "actionGetLabs",
      "actionSaveSingleMilkControl"
    ]),
    ...mapActions("milk_control", [
      "actionSaveMilkControl",
      "actionGetLabSync"
    ]),
    checkAverageWeight() {
      this.allAnimals.forEach(animal => {
        if(animal.average_production) {
          const average_weight = 
            (parseFloat(animal.first_weight) + 
            parseFloat(animal.second_weight) + 
            parseFloat(animal.third_weight)) / 4;
            if(average_weight >= (animal.average_production * 1.4)) {
              animal.error = "soma das ordenhas 40% acima da média";
            }
            else {
              animal.error = null;
            }
        }
      });
      this.tableKey++;
    },
    async getLabSync() {
      try {
        const result = await this.actionGetLabSync({
          service_id: this.service_single.id,
          partner: this.integrations,
          analysis_date: this.service.date_analysis
        });
        if(result.imported) {
          await this.refreshImportedAnalysis();
          this.$toast.success(`${result.imported} análise(s) importada(s) da Parleite`);
        } else if(result.protocols) {
          this.$toast.warning("Nenhuma análise deste serviço encontrada nos protocolos da Parleite");
        } else {
          this.$toast.warning("Nenhum protocolo da Parleite encontrado para a data deste serviço");
        }
      } catch(error) {
        this.$toast.error(error.response?.data?.error || "Não foi possível consultar a Parleite");
      }
    },
    prepareAnimal(serviceAnimal) {
      return {
        ...serviceAnimal,
        ...serviceAnimal.animal,
        id: serviceAnimal.id,
        animal_id: serviceAnimal.animal.id,
        fat: serviceAnimal.fat === "0.0" ? "" : serviceAnimal.fat,
        protein: serviceAnimal.protein === "0.0" ? "" : serviceAnimal.protein,
        lactose: serviceAnimal.lactose === "0.0" ? "" : serviceAnimal.lactose,
        ccs: serviceAnimal.ccs === 0 ? "" : serviceAnimal.ccs,
        solids: serviceAnimal.solids === 0 ? "" : serviceAnimal.solids,
        date_classified: this.parseDate(this.service.date),
        fat_errors: {value:"", valid:true, tooltip:""},
        lactose_errors: {value:"", valid:true, tooltip:""},
        protein_errors: {value:"", valid:true, tooltip:""},
        urea_errors: {value:"", valid:true, tooltip:""},
        ccs_errors: {value:"", valid:true, tooltip:""},
        solids_errors: {value:"", valid:true, tooltip:""}
      };
    },
    async refreshImportedAnalysis() {
      const currentPage = new Map(this.allAnimals.map(animal => [animal.id, animal]));
      const stored = JSON.parse(localStorage.getItem("form-milk-analysis") || "[]")
        .map(animal => currentPage.get(animal.id) || animal);
      const refreshed = await this.actionGetSingleService(this.service_single.id);
      const latest = new Map(refreshed.service_animals.map(animal => [animal.id, animal]));
      const fields = ["fat", "protein", "lactose", "urea", "ccs", "solids"];
      const merged = stored.map(animal => {
        const server = latest.get(animal.id);
        if(!server) return animal;
        const preparedServer = this.prepareAnimal(server);
        const previous = this.originalLabValues[animal.id] || {};
        const result = { ...animal, has_analysis: server.has_analysis, sync_at: server.sync_at };
        fields.forEach(field => {
          if(String(animal[field] ?? "") === String(previous[field] ?? "")) {
            result[field] = preparedServer[field];
          }
        });
        this.originalLabValues[animal.id] = preparedServer;
        return result;
      });
      localStorage.setItem("form-milk-analysis", JSON.stringify(merged));
      const mergedById = new Map(merged.map(animal => [animal.id, animal]));
      this.allAnimals = this.allAnimals.map(animal => mergedById.get(animal.id) || animal);
      if(!this.service.date_analysis) this.service.date_analysis = refreshed.date_analysis;
    },
    //Esse metedo calcula as regras de decimais das strings 
    returnFloat(value) {
      return value.toString().replaceAll(",", ".");
    },
    async saveSingleMilkControl(item) {
      const animalPayload = {};
      animalPayload.id = item.id;
      animalPayload.animal_id = item.animal_id;
      // campo vazio vai como null (antes o null.toString() quebrava o salvar)
      const toNumber = value => (value === null || value === undefined || value === "") ? null : parseFloat(value.toString().replaceAll(",", "."));
      ["fat", "protein", "lactose", "urea", "ccs", "solids"].forEach(attr => { animalPayload[attr] = toNumber(item[attr]); });
      animalPayload.classified_comment = item.classified_comment || null;
      animalPayload.control_next = item.control_next;
      try {
        await this.actionSaveSingleMilkControl(
          {
            id:this.service_single.id,
            farm:this.service_single.farm,
            service_animals_attributes:[
              animalPayload 
            ]
          }
        );
        this.$toast.success("Análise salva com sucesso !");
      } catch(error) {
        this.$toast.error(error);
      }
    },
    async removeSingleMilkControl() {
      const animalPayload = {};
      animalPayload.id = this.analysisToDelete.id;
      animalPayload.animal_id = this.analysisToDelete.animal_id;
      animalPayload.has_analysis = false;
      try {
        await this.actionSaveSingleMilkControl(
          {
            id:this.service_single.id,
            farm:this.service_single.farm,
            service_animals_attributes:[
              animalPayload 
            ]
          }
        );
        const indexOf = this.allAnimals.findIndex(e => e.id === this.analysisToDelete.id);
        this.allAnimals[indexOf].has_analysis = false;
        this.$toast.success("Análise removida com sucesso !");
        this.showConfirmationRemoveAnalysis = false;
      } catch(error) {
        this.$toast.error(error);
      }
    },
    checkStringLength(animal, attr) {
      let value = null;
      if(animal[attr].includes(".")) {
        value = animal[attr].replaceAll(".",",");
      } else {
        value = animal[attr].replaceAll(".",",");
      }
      const [a,b] = value.split(",");
      const splited = b?.split("");
      if(attr === "ccs" && animal[attr].includes(",") || attr === "ccs" && animal[attr].includes(".")) {
        this.computedAnimals.forEach(e => {
          if(animal.id === e.id) {
            const newValue = Math.round(parseFloat(e[attr]));
            e[attr] = newValue;
          }
        });
        this.ccs_check(animal);
      } else {
        if(splited?.length > 2) {
        this.computedAnimals.forEach(e => {
          if(animal.id === e.id) {
            e[attr]= a+","+splited?.slice(0,2).join().replaceAll(",", "")
          }
          });
          this.fat_check(animal);
          this.protein_check(animal);
          this.lactose_check(animal);
        }
      }
      
    },
    //Esse metodo salva a analise do leite
   async saveAnalysis() {
     let list = JSON.parse(localStorage.getItem("form-milk-analysis"));
     let animals = [];
     list.forEach(item => {
       this.computedAnimals.forEach(e => {
         if(item.animal_id === e.animal_id) {
           item = e;
         }
       })
       animals.push(item);
     });
     // validação para campos obrigatório e dinamica de PI
     const invalid = animals.filter(e => e.fat_errors?.valid === false || 
      e.protein_errors?.valid === false ||  e.lactose_errors?.valid === false ||
      e.ccs_errors?.valid === false || e.solids_errors?.valid === false);
     const pi_check = invalid.filter(e => !e.control_next || e.control_next === false);
    if(pi_check.length) {
      this.$toast.warning(`Animais ${invalid.map(e => {return e.animal.name}).join()} possuem atributos inválidos`);
      return
    }
    const today = new Date();
    const day = today.getDate();
    let month = today.getMonth() + 1;
    if(month < 10) {
      month = "0"+(today.getMonth() + 1)
    }
    const year = today.getFullYear();
    const payload = {
      service_id:this.service.id,
      service:{
        date_classified:this.service.date_classified.trim().length ? this.service.date_classified : year+"-"+month+"-"+day,
        date_analysis:this.service.date_analysis,
        labor_id:this.service.labor_id,
        analysis_outdate:this.service.analysis_outdate,
        service_animals_attributes:[
          // animal marcado para o próximo controle (PI) vai só com a marcação, sem valores de análise
          ...animals.filter(animal => animal.control_next).map(animal => ({id:animal.id, control_next:true})),
          ...animals.filter(animal => !animal.control_next).map(animal => ({
            id:animal.id,
            control_next:false,
            fat:parseFloat(animal.fat.toString().replaceAll(",", ".")),
            protein:parseFloat(animal.protein.toString().replaceAll(",", ".")),
            urea:parseFloat(animal.urea ? animal.urea.toString().replaceAll(",", ".") : null),
            ccs:parseInt(animal.ccs.toString().replaceAll(",", ".")),
            lactose:parseFloat(animal.lactose.toString().replaceAll(",", ".")),
            solids:animal.solids ? parseFloat(animal.solids.toString().replaceAll(",", ".")) : null,
            classified_comment:animal.classified_comment
          }))
        ]
       }
     };
     try {
      await this.actionSaveMilkControl(payload);
      this.$toast.success("Análise do leite cadastrada com sucesso");
      this.$router.push({name:"Milk-analysis-list"}); 
     } catch(error) {
       this.$toast.error("Erro ao salvar a análise");
     } 
    },
    //metodos para alterar dinamicamente os erros dos atributos invalidos
    solids_check(animal) {
      this.computedAnimals.forEach(e => {
        if(e.id === animal.id) {
          const value = parseFloat(this.returnFloat(animal.solids || 0));
          e.solids_errors = (value >= 0 && value <= 100) ? {value:"", valid:true, tooltip:""} : {value:" ", valid:false, tooltip:"Valor deve ser maior ou igual a 0 e menor ou igual a 100"}
        }
      });
      this.keysUpdate.inputSolidsKey = this.keysUpdate.inputSolidsKey + 1;
    },
    fat_check(animal) {
      this.computedAnimals.forEach(e => {
        if(e.id === animal.id) {
          e.fat_errors = (parseFloat(this.returnFloat(animal.fat)) >= 0.5 && parseFloat(this.returnFloat(animal.fat)) <= 18) ? {value:"", valid:true, tooltip:""} : {value:" ", valid:false, tooltip:"Valor deve ser maior ou igual a 0,5 e menor ou igual a 18"}
        }
      });
      this.keysUpdate.inputFatKey = this.keysUpdate.inputFatKey + 1;
    },
    protein_check(animal) {
      this.computedAnimals.forEach(e => {
        if(e.id === animal.id) {
          e.protein_errors = (parseFloat(this.returnFloat(animal.protein)) >= 0.5 && parseFloat(this.returnFloat(animal.protein)) <= 12) ? {value:"", valid:true, tooltip:""} : {value:" ", valid:false, tooltip:"Valor deve ser maior ou igual a 0,5 e menor ou igual a 12"}
        }
      });
      this.keysUpdate.inputProteinKey = this.keysUpdate.inputProteinKey + 1;
    },
    lactose_check(animal) {
      this.computedAnimals.forEach(e => {
        if(e.id === animal.id) {
          e.lactose_errors = (parseFloat(this.returnFloat(animal.lactose)) >= 0.5 && parseFloat(this.returnFloat(animal.lactose)) <= 12) ? {value:"", valid:true, tooltip:""} : {value:" ", valid:false, tooltip:"Valor deve ser maior ou igual a 0,5 e menor ou igual a 12"}
        }
      });
      this.keysUpdate.inputLactoseKey = this.keysUpdate.inputLactoseKey + 1;
    },
    urea_check(animal) {
      this.computedAnimals.forEach(e => {
        if(e.id === animal.id) {
          e.urea_errors = {value:"", valid:true, tooltip:""}
        }
      });
      this.keysUpdate.inputUreaKey = this.keysUpdate.inputUreaKey + 1;
    },
    ccs_check(animal) {
      this.computedAnimals.forEach(e => {
        if(e.id === animal.id) {
          e.ccs_errors = (parseInt(animal.ccs) >= 1 && parseInt(animal.ccs) <= 10000) ? {value:"", valid:true, toolbar:""} : {value:" ", valid:false, toolbar:"Valor deve ser maior ou igual a 1 e menor ou igual a 10000"}
        }
      });
      this.keysUpdate.inputCssKey = this.keysUpdate.inputCssKey + 1;
    }
  },
  watch: {
    "service.analysis_outdate": function(val) {
      if(val) {
        this.allAnimals.forEach(e => {
          e.control_next = true;
          e.classified_comment = "amostra vencida";
        });
      } else {
        this.allAnimals.forEach(e => {
          e.control_next = false;
          e.classified_comment = "";
        });
      }
    }
  },
  async mounted() {
    const {id} = this.$route.params;
    await this.actionGetLabs();
    await this.actionGetServices({summary:true});
    if(id) {
      await this.actionGetSingleService(id);
      this.service = {...this.service_single, labor_id:this.service_single.labor?.id};
        const selectedService = this.services.find(item => item.id === id);
        if(!selectedService) {
          this.computedServices.push({...this.service, title:this.service.code + " - " + this.service.status});
          this.serviceSelectKey = this.serviceSelectKey + 1;
        }
        this.canChangeService = true;
    } else {
      this.canChangeService = true;
    }
    if(this.service.service_animals.length) {
      this.service.service_animals.forEach(e => {
        const filtered = e.lactation.split(",");
        e.lactation = filtered.filter(e => e === "38");
      })
      this.originalLabValues = Object.fromEntries(this.service.service_animals.map(animal => [animal.id, this.prepareAnimal(animal)]));
      this.allAnimals.push(...this.service.service_animals
        .filter(animal => (!animal.lactation.length || animal.lactation.find(e => e !== "38")))
        .map(animal => this.prepareAnimal(animal))
      );
      this.checkAverageWeight();
      localStorage.setItem("form-milk-analysis", JSON.stringify(this.allAnimals));
      this.total_pages = Math.ceil(this.allAnimals.length / this.valuePerPage);
      this.total_items = this.allAnimals.length;
      this.allAnimals = this.allAnimals.filter((a,i) => i < this.valuePerPage);
      this.in_page = this.valuePerPage;
    }
  }
}
</script>

<style scoped>
  @media screen and (max-width:1140px) {
    .table-header-control {
      flex-direction: column;
      align-items: start !important;
    }

    .table-header-control .table-header-control-paginator {
      padding: 0 !important;
    }
  }
  .sync-sample {
    background: var(--jersey-yellow) !important;
    color: white !important;
  }
</style>
